(function () {

    'use strict';

    angular.module('iplusjs.typeahead', [
        'lodash',
        'fuzzysort',
        'iplusjs.filter.highlightQuery',
        'iplusjs.loadingIndicator',
        'iplusjs.list.table',
        'iplusjs.validationMessage',
        'iplusjs.utils.html'
    ])
        .component('iplusjsTypeahead', {
            templateUrl: 'common/typeahead/typeahead.html',
            require: {
                ngModelCtrl: 'ngModel',
                form: '^?form',
                fieldset: '^?iplusjsFieldset'
            },
            bindings: {
                name: '@name',
                validationName: '@itValidationName',
                value: '<ngModel',
                data: '<itData',
                dataPromise: '<itDataPromise',
                showAllLinkText: '@itShowAllLinkText',
                onChange: '&itOnChange',
                onInput: '&itOnInput',
                shouldReset: '<itShouldReset',
                options: '<itOptions'
            },
            controller: TypeaheadController,
            controllerAs: 'typeaheadVm'
        });

    TypeaheadController.$inject = [
        '$scope',
        '$log',
        '$filter',
        '$q',
        '$element',
        '$window',
        'lodash',
        'fuzzysort',
        'HtmlUtilsService'
    ];
    function TypeaheadController($scope, $log, $filter, $q, $element, $window, _, fuzzysort, HtmlUtilsService) {
        var vm = this,
            debounceTime,
            debouncedSearch,
            searchElem,
            compiledDisplayTemplate,
            compiledDisplayTemplateNoElement,
            keyCodes = {
                ENTER: 13,
                UP: 38,
                DOWN: 40,
                LEFT: 37,
                RIGHT: 39
            };

        vm.$onInit = onInit;
        vm.$onChanges = onChanges;

        vm.showAll = showAll;
        vm.onSearch = onSearch;
        vm.onFocus = onFocus;
        vm.setValue = setValue;
        vm.onKeydownSearchField = onKeydownSearchField;
        vm.onListNavigation = onListNavigation;
        vm.isLinkShowAllErlaubt = isLinkShowAllErlaubt;
        vm.isDisabled = isDisabled;

        function activate() {
            vm.options = vm.options || {};

            debounceTime = _.isNil(vm.options.debounceTime) ? 400 : vm.options.debounceTime;
            debouncedSearch = _.debounce(search, debounceTime);

            vm.options.fuzzySearchThreshold = _.isNil(vm.options.fuzzySearchThreshold) ? -145000 : vm.options.fuzzySearchThreshold;
            vm.highlightResult = _.isNil(vm.options.highlightResult) ? true : vm.options.highlightResult;
            vm.ariaErrorMessage = _.join(vm.options.ariaErrorMessage || [], ' ');

            vm.isSearchMode = false;
            vm.listOptions = {};
            vm.shouldShowAll = false;
            vm.directSelect = false;
            vm.matches = [];
            vm.filteredData = [];
            vm.displayProperty = vm.options.displayProperty || vm.options.valueProperty || 'bezeichnung';
            vm.trackByProperty = vm.options.trackByProperty;
            vm.listColumns = [{
                attr: [vm.displayProperty]
            }];

            if (_.isEmpty(_.get(vm.value, vm.displayProperty)) && _.size(vm.data) > 0) {
                vm.value = _.filter(vm.data, [vm.trackByProperty, _.get(vm.value, vm.trackByProperty)])[0];
            }

            vm.searchTerm = getDisplayString(vm.value);
            vm.displayValue = vm.searchTerm;
            vm.autocomplete = $element[0].getAttribute('autocomplete') || 'off';

            vm.validationName = vm.validationName || vm.name;
            vm.trackingName = vm.options.trackingName || vm.validationName;
            vm.trackingWithValue = !!vm.options.trackingWithValue;
            vm.filterLocal = _.isNil(vm.options.filterLocal) ? true : vm.options.filterLocal;
            vm.newDataElement = vm.options.newDataElement;
            vm.showAllOnFocus = vm.options.showAllOnFocus;
            vm.placeholder = _.get(vm.options.validation, 'placeholders');
            vm.showMessageOnValidate = _.isNil(_.get(vm.options.validation, 'showMessageOnValidate')) ? true : _.get(vm.options.validation, 'showMessageOnValidate');
            $scope.$watch(function () {
                return vm.form.$submitted;
            }, function (submitted) {
                if (submitted) {
                    vm.isSearchMode = false;
                }
            });
            $scope.$watch(function () {
                return vm.ngModelCtrl.$invalid && !vm.isSearchMode;
            }, function (invalid) {
                vm.modelInvalid = invalid;
            });

            $scope.$watch(function () {
                return $element[0].classList.contains('invalid');
            }, function (invalid) {
                vm.ariaInvalid = invalid;
            });
        }

        function onInit() {
            searchElem = $element.find('input')[0];

            activate();
        }

        function onChanges(changes) {
            var shouldResetChange = changes.shouldReset,
                valueChange = changes.value;

            if (shouldResetChange && !shouldResetChange.isFirstChange() && shouldResetChange.currentValue) {
                vm.value = null;
                vm.searchTerm = getDisplayString(vm.value);
                vm.shouldReset = null;
            } else if (valueChange && !valueChange.isFirstChange() && valueChange.currentValue && !vm.searchInProgress) {
                vm.searchTerm = getDisplayString(vm.value);
                vm.useSearchTermOnHttpError = false;
            }

            if (
                changes.dataPromise && !changes.dataPromise.isFirstChange() ||
                changes.options && !changes.options.isFirstChange()
            ) {
                activate();
            }

            if (changes.options && _.get(changes.options, 'currentValue.displayStyle') !== _.get(changes.options, 'previousValue.displayStyle')) {
                vm.cls = vm.options.displayStyle; // 'popover'

                activate();
                if (vm.options.displayStyle === 'popover') {
                    angular.element($window).on('click', function (event) {
                        var path = event.path || (event.composedPath && event.composedPath()) || HtmlUtilsService.composedPath(event.target);

                        if (!HtmlUtilsService.hasElement(path, ['IPLUSJS-TYPEAHEAD'])) {
                            vm.isSearchMode = false;
                        }
                    });
                }

                compiledDisplayTemplate = _.template(vm.options.displayTemplate || '<%= data["' + vm.displayProperty + '"] %>', { variable: 'data' });
                compiledDisplayTemplateNoElement = _.template('<%= data["' + vm.displayProperty + '"] %>', { variable: 'data' });
            }
        }
        function search(showAll, showAllLocalData) {
            var unifiedSearchTerm = getUnifiedSearchTerm(vm.searchTerm),
                fuzzySearchResults;

            vm.searchInProgress = false;

            if (_.isEmpty(vm.searchTerm) && vm.options.showAllOnFocus && _.size(vm.data) > 0 && !showAll && !showAllLocalData) {
                onFocus();
                return;
            }

            if (!_.isEmpty(vm.searchTerm) && !_.isNil(vm.options.minSearchLength) && _.size(vm.searchTerm) < vm.options.minSearchLength) {
                return;
            }

            vm.isSearchMode = true;
            vm.isLoading = true;
            vm.noMatches = false;
            vm.matches = [];
            vm.onChange({
                value: null,
                matches: vm.matches
            });

            getData(showAll, showAllLocalData).then(function (data) {
                if (vm.options.fuzzySearch) {
                    fuzzySearchResults = fuzzysort.go(vm.searchTerm, data, {
                        key: vm.options.fuzzySearchKey || vm.displayProperty,
                        threshold: vm.options.fuzzySearchThreshold,
                        all: showAll || showAllLocalData
                    });

                    fuzzySearchResults = _.orderBy(fuzzySearchResults, ['score', 'target'], ['desc', 'asc']);

                    vm.filteredData = _.unionBy(_.map(fuzzySearchResults, function (result) {
                        return result.obj;
                    }), showAll || showAllLocalData ? data : [], vm.trackByProperty);
                } else {
                    vm.filteredData = _.filter(data, function (obj) {
                        return showAll || showAllLocalData || vm.filterLocal === false ? true : (new RegExp(_.escapeRegExp(unifiedSearchTerm), 'gi')).test(getUnifiedSearchTerm(getDisplayString(obj, vm.options.displayTemplateData)));
                    });
                }

                if (_.isFunction(vm.options.filterFn)) {
                    vm.filteredData = vm.options.filterFn(vm.filteredData, vm.searchTerm);
                }

                if (vm.options.directSelectSingleExactMatch && !vm.useSearchTermOnHttpError) {
                    if (_.size(vm.filteredData) === 1 && vm.searchTerm === getDisplayString(vm.filteredData[0], vm.options.displayTemplateData)) {
                        vm.directSelect = true;
                        vm.isLoading = false;
                        vm.isSearchMode = false;
                        setValue(vm.filteredData[0]);
                    }
                }
            }).finally(function () {
                if (_.isEmpty(vm.searchTerm) && !showAll && !showAllLocalData) {
                    vm.isSearchMode = false;
                }

                if (vm.directSelect !== true) {
                    vm.ngModelCtrl.$setViewValue(null);
                    vm.isLoading = false;

                    if (vm.useSearchTermOnHttpError) {
                        vm.filteredData = vm.matches = [_.set({}, vm.displayProperty, getDisplayString(_.set({}, vm.displayProperty, vm.searchTerm)))];
                    } else if (vm.useSearchTermOnNoData) {
                        if (_.size(vm.filteredData) === 0 && vm.searchTerm) {
                            vm.filteredData = vm.matches = [_.set({}, vm.displayProperty, getDisplayString(_.set({}, vm.displayProperty, vm.searchTerm)))];

                            if (vm.options.directSelectOnNoData) {
                                vm.directSelect = true;
                                vm.isLoading = false;
                                vm.isSearchMode = false;
                                setValue(vm.filteredData[0]);
                            }
                        }
                    } else {
                        if (vm.options.fuzzySearch) {
                            vm.matches = _.unionBy(_.map(fuzzySearchResults, function (result) {
                                return _.merge({}, result.obj, _.set({}, vm.displayProperty, (vm.highlightResult && vm.searchTerm ? result.highlight('<strong>', '</strong>') : _.get(result.obj, vm.displayProperty)) + (_.get(result.obj, 'displaySuffix') ? _.get(result.obj, 'displaySuffix') : '')));
                            }), showAll || showAllLocalData ? vm.filteredData : [], vm.trackByProperty);
                        } else {
                            vm.matches = _.map(vm.filteredData, function (data) {
                                return _.merge({}, data, _.set({}, vm.displayProperty, (getHighlightedMatch(getDisplayString(data, vm.options.displayTemplateData), vm.searchTerm) || getHighlightedMatch(getDisplayString(data, vm.options.displayTemplateData), unifiedSearchTerm) || getDisplayString(data, vm.options.displayTemplateData)) + (data.displaySuffix ? data.displaySuffix : '')));
                            });
                        }

                        if (vm.newDataElement && !_.isEmpty(vm.searchTerm)) {
                            vm.matches.unshift(vm.newDataElement);
                            vm.filteredData.unshift(vm.newDataElement);
                        }

                        if (!_.size(vm.matches)) {
                            vm.noMatches = true;
                        }
                    }
                }

                vm.directSelect = false;
            });
        }
        function getUnifiedSearchTerm(searchTerm) {
            searchTerm = HtmlUtilsService.escapeHTML(searchTerm);

            if (vm.options.unifySearchTerm === false) {
                return searchTerm;
            } else {
                var umlaute = {
                        ä: 'ae',
                        ü: 'ue',
                        ö: 'oe',
                        ß: 'ss'
                    },
                    regexpUmlaute = new RegExp('[' + _.keys(umlaute).join('') + ']', 'gi'),
                    unifiedSearchTerm;
                unifiedSearchTerm = searchTerm.replace(regexpUmlaute, function (char) {
                    return umlaute[_.toLower(char)] || char;
                });

                return unifiedSearchTerm;
            }
        }
        function showAll() {
            vm.shouldShowAll = true;
            vm.displayValue = null;
            vm.searchTerm = null;

            if (vm.searchTerm) {
                vm.listOptions = {
                    scrollToTop: false,
                    scrollToSelected: true,
                    focusFirst: true
                };
            } else {
                vm.listOptions = {
                    scrollToTop: true,
                    focusFirst: true
                };
            }

            search(true);
        }
        function onSearch() {
            vm.shouldShowAll = false;
            vm.displayValue = null;
            vm.noMatches = false;
            vm.searchInProgress = true;

            vm.onInput();

            debouncedSearch();
        }
        function onFocus() {
            if (!_.isEmpty(vm.searchTerm) && !vm.ngModelCtrl.$viewValue) {
                vm.isSearchMode = true;
                vm.listOptions = {
                    focusFirst: false
                };
                search();
            } else if (_.isEmpty(vm.searchTerm) && vm.options.showAllOnFocus && _.size(vm.data) > 0) {
                vm.shouldShowAll = true;
                search(false, true);
            }
        }
        function onKeydownSearchField(event) {
            event = event || {};
            if (event.keyCode === keyCodes.DOWN) {
                vm.listOptions = {
                    focusFirst: true
                };
            } else {
                vm.listOptions = {
                    focusFirst: false
                };
            }
        }
        function onListNavigation(event, item) {
            event = event || {};

            var elem = event.target,
                otherElem,
                focusSearchField = false;

            if (!elem) {
                return;
            }

            if (keyCodes.DOWN === event.keyCode) {
                otherElem = elem.nextElementSibling;

            } else if (keyCodes.UP === event.keyCode) {
                otherElem = elem.previousElementSibling;
                focusSearchField = otherElem ? false : true;
            }

            if (focusSearchField && searchElem) {
                searchElem.focus();
            }

            if (otherElem && angular.isFunction(otherElem.focus)) {
                otherElem.focus();
            }
        }
        function setValue(item) {
            var modelValue,
                matches = _.clone(vm.matches);
            if (vm.trackByProperty) {
                modelValue = _.find(vm.filteredData, [vm.trackByProperty, _.get(item, vm.trackByProperty)]);
            } else {
                modelValue = item;
            }

            vm.isSearchMode = false;
            vm.ngModelCtrl.$setViewValue(modelValue);
            if (vm.newDataElement) {
                if (modelValue === vm.newDataElement && vm.options.valueProperty) {
                    modelValue[vm.options.valueProperty] = vm.searchTerm;
                }
            }

            vm.searchTerm = getDisplayString(modelValue);
            vm.displayValue = vm.searchTerm;
            vm.matches = [_.merge({}, item, _.set({}, vm.displayProperty, vm.searchTerm))];

            vm.shouldShowAll = false;

            $scope.$emit('iplusjs:tracking:triggerChangeEvent', [ _.get(vm.form['typeahead_' + vm.name], '$$element') ], {
                force: true
            });

            vm.onChange({
                value: modelValue,
                matches: matches
            });

            vm.matches = [];
        }
        function getHighlightedMatch(match, highlightQuery) {
            if (!vm.options.fuzzySearch && vm.highlightResult) {
                return $filter('highlightQuery')(match, highlightQuery);
            } else {
                return match;
            }
        }
        function getDisplayString(item, displayTemplateData) {
            if (!compiledDisplayTemplate) {
                compiledDisplayTemplate = _.template(vm.options.displayTemplate || '<%= data["' + vm.displayProperty + '"] %>', { variable: 'data' });
            }

            if (!compiledDisplayTemplateNoElement) {
                compiledDisplayTemplateNoElement = _.template('<%= data["' + vm.displayProperty + '"] %>', { variable: 'data' });
            }

            if (!_.isEmpty(item) && _.isString(item) && !vm.isSearchMode) {
                return item;
            }

            var data = _.merge({}, item, displayTemplateData);

            if (vm.useSearchTermOnHttpError || vm.useSearchTermOnNoData) {
                return compiledDisplayTemplateNoElement(data);
            } else {
                return (_.isEmpty(item) || !_.isObject(item)) ? '' : compiledDisplayTemplate(data);
            }
        }
        function getData(showAll, showAllLocalData) {
            return $q(function (resolve, reject) {
                if (vm.data && showAllLocalData) {
                    return resolve(vm.data);
                }

                if (_.isEmpty(vm.searchTerm) && !showAll) {
                    return resolve([]);
                }

                if (vm.data && !vm.dataPromise) {
                    return resolve(vm.data);
                }
                return vm.dataPromise({
                    filter: showAll ? '' : getUnifiedSearchTerm(vm.searchTerm)
                }).then(function (data) {
                    vm.useSearchTermOnHttpError = false;

                    if (_.size(data) === 0) {
                        if (vm.options.useSearchTermOnNoData) {
                            vm.useSearchTermOnNoData = true;
                        }
                    } else {
                        vm.useSearchTermOnNoData = false;
                    }
                    if (showAll) {
                        vm.data = data;
                    }

                    resolve(data);
                }).catch(function () {
                    vm.useSearchTermOnNoData = false;

                    if (vm.options.useSearchTermOnHttpError) {
                        vm.useSearchTermOnHttpError = true;
                    }
                    resolve([]);
                });
            });
        }
        function isLinkShowAllErlaubt() {
            return (
                vm.showAllLinkText &&
                !vm.shouldShowAll &&
                !isDisabled()
            );
        }
        function isDisabled() {
            return (
                (
                    vm.fieldset &&
                    vm.fieldset.disabled
                ) || (
                    vm.options.disabled
                )
            );
        }
    }

})();
